<div class="container-xl">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (form()?.get('id').value && (Features.CheckpointsDetailDelete | hasFeature)) {
            <button (click)="openDelete($event)" color="warning" mat-icon-button>
                <mat-icon fontIcon="fa-trash" fontSet="fas"></mat-icon>
            </button>
        }
    </div>

    @if (form()) {
        <div [formGroup]="form()" class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <b>Naam</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="name" matInput name="name" placeholder="Naam">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Platform</b>
                        <ng-select [items]="platforms()" [searchable]="true" bindLabel="name" bindValue="id" formControlName="platform_id">
                        </ng-select>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <b>URL</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="url" matInput name="url" placeholder="URL">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col">
                        <b>Niveau</b>
                        <ng-select [searchable]="true" bindLabel="name" bindValue="id" formControlName="level">
                            <ng-option [value]="checkpointLevels.PRODUCTION">{{checkpointLevels.PRODUCTION}}</ng-option>
                            <ng-option [value]="checkpointLevels.HEALTH">{{checkpointLevels.HEALTH}}</ng-option>
                            <ng-option [value]="checkpointLevels.CHECK">{{checkpointLevels.CHECK}}</ng-option>
                            <ng-option [value]="checkpointLevels.ACCEPTANCE">{{checkpointLevels.ACCEPTANCE}}</ng-option>
                        </ng-select>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Startdatum</b>
                        <div>
                            <mat-form-field>
                                <input (focus)="pickerStart.open()" [matDatepicker]="pickerStart" [min]="minDate" formControlName="start_date" matInput placeholder="Startdatum">
                                <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerStart></mat-datepicker>
                                <mat-error [control]="form().get('start_date')"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Einddatum</b>
                        <div>
                            <mat-form-field>
                                <input (focus)="pickerEnd.open()" [matDatepicker]="pickerEnd" [min]="minDate" formControlName="end_date" matInput placeholder="Einddatum">
                                <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                                <mat-datepicker #pickerEnd></mat-datepicker>
                                <mat-error [control]="form().get('end_date')"></mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>externe IP</b>
                        <i
                            class="fa fa-info-circle ms-2"
                            matTooltip="Let op, zodra externe IP is gevuld word de checkpoint niet meer uitegevoerd en kan het alleen via de externe logging resultaten verwerken"
                            matTooltipPosition="above"></i>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="external_ip_allowed" matInput name="external_ip_allowed" placeholder="Externe IP">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Valide reactiecode</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="valid_response_code" matInput name="valid_response_code" placeholder="Valide reactiecode">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Waarschuwings reactiecode</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="warning_response_code" matInput name="warning_response_code" placeholder="Waarschuwings reactiecode">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Valideer SSL</b>
                        <ng-select [clearable]="false" [searchable]="false" bindLabel="name" bindValue="id" formControlName="validate_ssl">
                            <ng-option [value]="false">Nee</ng-option>
                            <ng-option [value]="true">Ja</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-auto">
                        <b>Sla response ook op zonder error</b>
                        <div class="row">
                            <ng-select [clearable]="false" [searchable]="false" bindLabel="name" bindValue="id" formControlName="save_contents_on_success">
                                <ng-option [value]="false">Nee</ng-option>
                                <ng-option [value]="true">Ja</ng-option>
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <div class="row">
                    <div class="col-auto">
                        <b>Pogingen</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="retries" matInput name="retries" placeholder="Pogingen" type="number">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Herhaal vertraging</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="retry_delay" matInput name="retry_delay" placeholder="Herhaal vertraging" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('retry_delay').value | msReadable"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Timeout</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="timeout" matInput name="timeout" placeholder="Timeout" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form().value.timeout | msReadable"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Interval</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="interval" matInput name="interval" placeholder="Interval" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form().value.interval | msReadable"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <b>Valid checksum</b>
                        <div class="row">
                            <mat-form-field>
                                <input formControlName="valid_checksum" matInput name="valid_checksum" placeholder="Valid checksum">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <h3>
                    <b>Validatie grootte van respons</b>
                </h3>
                <div class="row">
                    <div class="col-auto">
                        <b>Minimaal error</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="min_content_size_error" matInput name="min_content_size_error" placeholder="Minimaal error" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('min_content_size_error').value | bytesPipe"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Minimaal waarschuwing</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="min_content_size_warning" matInput name="min_content_size_warning" placeholder="Minimaal waarschuwing" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('min_content_size_warning').value | bytesPipe"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Maximaal waarschuwing</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="max_content_size_warning" matInput name="max_content_size_warning" placeholder="Maximaal waarschuwing" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('max_content_size_warning').value | bytesPipe"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Maximaal error</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="max_content_size_error" matInput name="max_content_size_error" placeholder="Maximaal error" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('max_content_size_error').value | bytesPipe"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-12">
                <h3>
                    <b>Validatie tijd van respons</b>
                </h3>
                <div class="row">
                    <div class="col-auto">
                        <b>Minimaal error</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="min_response_time_error" matInput name="min_response_time_error" placeholder="Minimaal error" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('min_response_time_error').value | msReadable"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Minimaal waarschuwing</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="min_response_time_warning" matInput name="min_response_time_warning" placeholder="Minimaal waarschuwing" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('min_response_time_warning').value | msReadable"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Maximaal waarschuwing</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="max_response_time_warning" matInput name="max_response_time_warning" placeholder="Maximaal waarschuwing" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('max_response_time_warning').value | msReadable"></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <b>Maximaal error</b>
                        <div class="row">
                            <div class="col">
                                <mat-form-field>
                                    <input formControlName="max_response_time_error" matInput name="max_response_time_error" placeholder="Maximaal error" type="number">
                                </mat-form-field>
                                <span [innerHTML]="form()?.get('max_response_time_error').value | msReadable"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (Features.CheckpointsSave | hasFeature) {
                <button (click)="save()" [disabled]="form()?.invalid || saving" class="btn btn-primary" type="submit">
                    Opslaan
                    @if (saving) {
                        <i class="fas fa-circle-notch fa-spin ml-2"></i>
                    }
                </button>
            }
        </div>
    }
</div>
